import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

type Props = {
  startupMetricsField: React.ReactNode;
};
export const StartupMetricsSettingsContainer = ({
  startupMetricsField,
}: Props) => {
  const { title, description, docsLinkKey } =
    vpaSettingsConstants.startupMetrics;

  return (
    <VerticalSettingsForm
      title={title}
      description={description}
      docsLinkKey={docsLinkKey}
    >
      {startupMetricsField}
    </VerticalSettingsForm>
  );
};
